import React from 'react';
import { Image as ImageType } from '../../commonTypes/image';
import { NonTextLink } from '../../commonTypes/links';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { ImageLink, ImageStyle } from './styles';

export type ImageProps = {
  image: ImageType;
  link?: NonTextLink;
  shouldEagerLoad?: boolean;
} & ComponentProps;

// className has been separated from componentProps below so that the component
// theme is applied to ImageLink so that it can be styled in the Theme overrides
const Image: React.FC<ImageProps> = ({
  image,
  link,
  shouldEagerLoad,
  className,
  ...props
}) =>
  link ? (
    <ImageLink
      className={className}
      href={link.url}
      aria-label={link.screenReaderText}
      onClick={link.onClick}>
      <ImageStyle
        {...componentProps(props)}
        src={image.url}
        alt={image.altText}
        height={image.height}
        width={image.width}
        shouldEagerLoad={shouldEagerLoad}
      />
    </ImageLink>
  ) : (
    <ImageStyle
      {...componentProps(props)}
      className={className}
      src={image.url}
      alt={image.altText}
      height={image.height}
      width={image.width}
      shouldEagerLoad={shouldEagerLoad}
    />
  );

export default applyComponentTheme(Image, 'Image');
